import { render, staticRenderFns } from "./StoreSubmitButton.vue?vue&type=template&id=edb01002&scoped=true&"
import script from "./StoreSubmitButton.vue?vue&type=script&lang=js&"
export * from "./StoreSubmitButton.vue?vue&type=script&lang=js&"
import style0 from "./StoreSubmitButton.vue?vue&type=style&index=0&id=edb01002&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb01002",
  null
  
)

export default component.exports